// Spanish translations
export const es: Record<string, string> = {
  // ==================== COMMON ====================
  'common.loading': 'Cargando...',
  'common.error': 'Ocurrió un error',
  'common.retry': 'Reintentar',
  'common.cancel': 'Cancelar',
  'common.save': 'Guardar',
  'common.continue': 'Continuar',
  'common.back': 'Atrás',
  'common.next': 'Siguiente',
  'common.skip': 'Omitir',
  'common.done': 'Hecho',
  'common.yes': 'Sí',
  'common.no': 'No',
  'common.ok': 'OK',
  'common.check': 'Verificar',
  'common.correct': '¡Correcto!',
  'common.incorrect': 'Incorrecto',
  'common.tryAgain': 'Intentar de nuevo',
  'common.start': 'Comenzar',
  'common.finish': 'Terminar',
  'common.submit': 'Enviar',

  // ==================== NAVIGATION ====================
  'nav.home': 'Inicio',
  'nav.courses': 'Cursos',
  'nav.vocabulary': 'Vocabulario',
  'nav.profile': 'Perfil',
  'nav.settings': 'Configuración',
  'nav.logout': 'Cerrar sesión',
  'nav.leaderboard': 'Clasificación',
  'nav.aiTutor': 'Tutor IA',

  // ==================== ONBOARDING ====================
  'onboarding.welcome': '¡Bienvenido a KoreanFlow!',
  'onboarding.selectLanguage': 'Selecciona tu idioma',
  'onboarding.selectLanguageDesc': 'Elige el idioma de la interfaz de la aplicación',
  'onboarding.selectGoal': '¿Cuál es tu objetivo de aprendizaje?',
  'onboarding.selectGoalDesc': 'Personalizaremos tu ruta de aprendizaje',
  'onboarding.takeTest': 'Realizar prueba de nivel',
  'onboarding.takeTestDesc': 'Descubre tu nivel de coreano en 5 minutos',
  'onboarding.skipTest': 'Omitir por ahora',
  'onboarding.skipTestDesc': 'Comenzar desde el principio',
  'onboarding.letsGo': '¡Vamos!',
  'onboarding.step': 'Paso',
  'onboarding.of': 'de',

  // ==================== LEVEL TEST ====================
  'levelTest.title': 'Prueba de Nivel',
  'levelTest.subtitle': 'Descubramos tu nivel de coreano',
  'levelTest.duration': 'Aproximadamente 5 minutos',
  'levelTest.questions': 'preguntas',
  'levelTest.vocabulary': 'Vocabulario',
  'levelTest.grammar': 'Gramática',
  'levelTest.listening': 'Comprensión auditiva',
  'levelTest.speaking': 'Expresión oral',
  'levelTest.analyzing': 'Analizando tus resultados...',
  'levelTest.yourLevel': 'Tu nivel',
  'levelTest.congratulations': '¡Felicidades!',
  'levelTest.resultDesc': 'Basado en los resultados de tu prueba',
  'levelTest.startLearning': 'Comenzar a aprender',
  'levelTest.retakeTest': 'Repetir prueba',
  'levelTest.sectionComplete': 'Sección completada',
  'levelTest.nextSection': 'Siguiente sección',
  'levelTest.listenAndAnswer': 'Escucha y responde',
  'levelTest.speakNow': 'Habla ahora',
  'levelTest.tapToListen': 'Toca para escuchar',

  // ==================== CEFR LEVELS ====================
  'cefr.A1': 'Principiante',
  'cefr.A2': 'Elemental',
  'cefr.B1': 'Intermedio',
  'cefr.B2': 'Intermedio alto',
  'cefr.C1': 'Avanzado',
  'cefr.C2': 'Maestría',
  'cefr.A1.desc': 'Saludos básicos y expresiones simples',
  'cefr.A2.desc': 'Conversaciones simples sobre la vida diaria',
  'cefr.B1.desc': 'Puede manejar la mayoría de situaciones de viaje',
  'cefr.B2.desc': 'Puede interactuar con fluidez con hablantes nativos',
  'cefr.C1.desc': 'Puede expresar ideas con fluidez y espontaneidad',
  'cefr.C2.desc': 'Dominio casi nativo en todas las situaciones',

  // ==================== LEAGUE / RANKING ====================
  'league.title': 'Liga',
  'league.weeklyRanking': 'Clasificación semanal',
  'league.bronze': 'Bronce',
  'league.silver': 'Plata',
  'league.gold': 'Oro',
  'league.platinum': 'Platino',
  'league.diamond': 'Diamante',
  'league.promotion': 'Zona de ascenso',
  'league.demotion': 'Zona de descenso',
  'league.safe': 'Zona segura',
  'league.weeklyXP': 'XP semanal',
  'league.rank': 'Posición',
  'league.daysLeft': 'días restantes',
  'league.promoted': '¡Ascendido!',
  'league.demoted': 'Descendido',
  'league.stayed': 'Mantenido',
  'league.noData': 'Sin datos de clasificación aún',
  'league.earnXP': '¡Gana XP para unirte a la liga!',
  'league.topPercent': 'Top {percent}%',

  // ==================== LANDING PAGE ====================
  'landing.tagline': 'App #1 para aprender coreano',
  'landing.title': 'Aprende coreano',
  'landing.titleAccent': 'de forma divertida',
  'landing.subtitle': 'Domina el coreano con lecciones breves, contenido de K-Pop y K-Drama, y retroalimentación de pronunciación con IA. ¡Únete a más de 1M de estudiantes!',
  'landing.getStarted': 'Comenzar gratis',
  'landing.learnMore': 'Más información',
  'landing.login': 'Iniciar sesión',
  'landing.startFree': 'Comenzar gratis',
  'landing.learners': 'Estudiantes',
  'landing.lessons': 'Lecciones',
  'landing.countries': 'Países',

  // ==================== FEATURES ====================
  'features.title': '¿Por qué KoreanFlow?',
  'features.subtitle': 'Nuestro enfoque único combina gamificación, contenido auténtico y tecnología de IA para hacer el aprendizaje del coreano divertido y efectivo.',
  'features.streaks.title': 'Rachas diarias',
  'features.streaks.desc': 'Crea un hábito con metas diarias y recompensas por racha. Mantente motivado con XP y gemas.',
  'features.folksong.title': 'Canciones tradicionales',
  'features.folksong.desc': 'Aprende coreano a través de canciones tradicionales. ¡Comprende las letras y la cultura!',
  'features.culture.title': 'Cultura coreana',
  'features.culture.desc': 'Explora proverbios, jerga y frases esenciales. Domina expresiones auténticas.',
  'features.ai.title': 'Chatbot IA',
  'features.ai.desc': 'Practica conversaciones con nuestro tutor IA. Obtén retroalimentación y correcciones instantáneas.',
  'features.leaderboard.title': 'Clasificaciones',
  'features.leaderboard.desc': 'Compite con amigos y estudiantes de todo el mundo. ¡Sube en los rankings semanales!',
  'features.srs.title': 'Vocabulario SRS',
  'features.srs.desc': 'El sistema de repetición inteligente asegura que recuerdes lo que aprendes. Para siempre.',
  'features.pronunciation.title': 'Retroalimentación de pronunciación',
  'features.pronunciation.desc': 'Análisis de pronunciación con IA con puntuación detallada.',

  // ==================== CTA ====================
  'cta.title': '¿Listo para comenzar tu viaje?',
  'cta.subtitle': 'Únete a millones de estudiantes y comienza a hablar coreano hoy. ¡Es gratis!',
  'cta.button': 'Comenzar a aprender gratis',

  // ==================== AUTH ====================
  'auth.login': 'Iniciar sesión',
  'auth.register': 'Registrarse',
  'auth.email': 'Correo electrónico',
  'auth.emailPlaceholder': 'Ingresa tu correo',
  'auth.password': 'Contraseña',
  'auth.passwordPlaceholder': 'Crea una contraseña',
  'auth.confirmPassword': 'Confirmar contraseña',
  'auth.forgotPassword': '¿Olvidaste tu contraseña?',
  'auth.noAccount': '¿No tienes cuenta?',
  'auth.haveAccount': '¿Ya tienes cuenta?',
  'auth.orContinueWith': 'o continuar con',
  'auth.google': 'Google',
  'auth.apple': 'Apple',
  'auth.createAccount': 'Crear cuenta',
  'auth.createAccountTitle': 'Crea tu cuenta',
  'auth.createAccountSubtitle': 'Comienza tu viaje de aprendizaje del coreano hoy',
  'auth.username': 'Nombre de usuario',
  'auth.usernamePlaceholder': 'Elige un nombre de usuario',
  'auth.usernameHint': 'Solo letras, números y guiones bajos',
  'auth.passwordHint': 'Al menos 8 caracteres con mayúscula, minúscula y número',
  'auth.nativeLanguage': 'Idioma nativo',
  'auth.nativeLanguageHint': 'Mostraremos las explicaciones en este idioma',
  'auth.termsAgree': 'Al registrarte, aceptas nuestros',
  'auth.terms': 'Términos',
  'auth.and': 'y',
  'auth.privacyPolicy': 'Política de privacidad',
  'auth.loginTitle': 'Bienvenido de nuevo',
  'auth.loginSubtitle': 'Inicia sesión para continuar aprendiendo',
  'auth.loginButton': 'Iniciar sesión',
  'auth.registerButton': 'Registrarse',
  'auth.rememberMe': 'Recordarme',

  // ==================== DASHBOARD ====================
  'dashboard.welcome': 'Bienvenido de nuevo',
  'dashboard.todayGoal': 'Meta de hoy',
  'dashboard.streak': 'Racha',
  'dashboard.days': 'días',
  'dashboard.xp': 'XP',
  'dashboard.level': 'Nivel',
  'dashboard.continueLearning': 'Continuar aprendiendo',
  'dashboard.recommended': 'Recomendado para ti',
  'dashboard.myCourses': 'Mis cursos',
  'dashboard.seeAll': 'Ver todo',
  'dashboard.dailyGoalComplete': '¡Meta diaria completada!',
  'dashboard.keepGoing': '¡Sigue así!',
  'dashboard.yourLevel': 'Tu nivel',
  'dashboard.weeklyProgress': 'Progreso semanal',

  // ==================== COURSES ====================
  'courses.title': 'Todos los cursos',
  'courses.search': 'Buscar cursos...',
  'courses.all': 'Todos',
  'courses.beginner': 'Principiante',
  'courses.elementary': 'Elemental',
  'courses.intermediate': 'Intermedio',
  'courses.advanced': 'Avanzado',
  'courses.lessons': 'lecciones',
  'courses.enrolled': 'inscritos',
  'courses.progress': 'Progreso',
  'courses.completed': 'completado',
  'courses.recommended': 'Recomendado',
  'courses.forYourLevel': 'Para tu nivel',
  'courses.locked': 'Bloqueado',
  'courses.unlockWith': 'Desbloquear con Premium',

  // ==================== LESSON ====================
  'lesson.loading': 'Cargando lección...',
  'lesson.notFound': 'Lección no encontrada',
  'lesson.quit': '¿Seguro que quieres salir? Tu progreso se perderá.',
  'lesson.complete': '¡Lección completada!',
  'lesson.perfect': '¡Perfecto!',
  'lesson.amazing': '¡Increíble! ¡Todo correcto!',
  'lesson.xpEarned': 'XP ganado',
  'lesson.accuracy': 'Precisión',
  'lesson.correct': 'Correcto',
  'lesson.goBack': 'Volver',
  'lesson.skip': 'Omitir',
  'lesson.unknownType': 'Tipo de ejercicio desconocido',

  // ==================== EXERCISES ====================
  'exercise.tapToReveal': 'Toca para revelar la respuesta',
  'exercise.matchPairs': 'Une los pares',
  'exercise.matched': 'unido',
  'exercise.arrangeWords': 'Ordena las palabras',
  'exercise.speak': 'Hablar',
  'exercise.listening': '¡Escuchando... Habla ahora!',
  'exercise.processing': 'Procesando tu voz...',
  'exercise.tapToSpeak': 'Toca para hablar',
  'exercise.cantSpeak': '¿No puedes hablar ahora? Omitir',
  'exercise.again': 'De nuevo',
  'exercise.gotIt': '¡Entendido!',

  // ==================== PRONUNCIATION ====================
  'pronunciation.title': 'Práctica de pronunciación',
  'pronunciation.subtitle': 'Mejora tu pronunciación coreana con retroalimentación de IA',
  'pronunciation.selectLevel': 'Selecciona tu nivel',
  'pronunciation.beginner': 'Principiante',
  'pronunciation.intermediate': 'Intermedio',
  'pronunciation.advanced': 'Avanzado',
  'pronunciation.score': 'Tu puntuación',
  'pronunciation.accuracy': 'Precisión',
  'pronunciation.fluency': 'Fluidez',
  'pronunciation.intonation': 'Entonación',
  'pronunciation.feedback': 'Retroalimentación',
  'pronunciation.tryAgain': 'Intentar de nuevo',
  'pronunciation.next': 'Siguiente',
  'pronunciation.listen': 'Escuchar',
  'pronunciation.slow': 'Lento',
  'pronunciation.sessionComplete': '¡Sesión completada!',
  'pronunciation.bestScore': 'Mejor puntuación',
  'pronunciation.average': 'Promedio',
  'pronunciation.attempts': 'Intentos',
  'pronunciation.practiceAgain': 'Practicar de nuevo',
  'pronunciation.changeLevel': 'Cambiar nivel',
  'pronunciation.tips': 'Consejos para mejor pronunciación',
  'pronunciation.tip1': 'Escucha el audio primero',
  'pronunciation.tip2': 'Habla claramente y a un ritmo constante',
  'pronunciation.tip3': 'Usa la reproducción lenta para palabras difíciles',
  'pronunciation.tip4': 'Practica en un ambiente tranquilo',

  // ==================== VOCABULARY ====================
  'vocab.title': 'Vocabulario',
  'vocab.totalWords': 'Total de palabras',
  'vocab.mastered': 'Dominadas',
  'vocab.dueToday': 'Para hoy',
  'vocab.reviewSession': 'Sesión de repaso',
  'vocab.wordsDue': 'palabras para repasar',
  'vocab.startReview': 'Comenzar repaso',
  'vocab.allCaughtUp': '¡Todo al día!',
  'vocab.noWordsDue': 'No hay palabras para repasar',
  'vocab.sessionComplete': '¡Sesión completada!',
  'vocab.allWords': 'Todas las palabras',

  // ==================== PROFILE ====================
  'profile.title': 'Perfil',
  'profile.level': 'Nivel',
  'profile.xpToNext': 'XP para siguiente nivel',
  'profile.totalXp': 'XP total',
  'profile.currentStreak': 'Racha actual',
  'profile.lessonsDone': 'Lecciones completadas',
  'profile.timeLearned': 'Tiempo estudiado',
  'profile.achievements': 'Logros',
  'profile.settings': 'Configuración',
  'profile.dailyGoals': 'Metas diarias',
  'profile.allAchievements': 'Todos los logros',
  'profile.logOut': 'Cerrar sesión',
  'profile.koreanLevel': 'Nivel de coreano',

  // ==================== SETTINGS ====================
  'settings.title': 'Configuración',
  'settings.language': 'Idioma de la app',
  'settings.preferences': 'Preferencias',
  'settings.sound': 'Efectos de sonido',
  'settings.soundEffects': 'Efectos de sonido',
  'settings.soundEffectsDesc': 'Reproducir sonidos al responder ejercicios',
  'settings.notifications': 'Notificaciones',
  'settings.notificationsDesc': 'Recibir recordatorios diarios de aprendizaje',
  'settings.darkMode': 'Modo oscuro',
  'settings.darkModeDesc': 'Tema oscuro para una visualización más cómoda',
  'settings.dailyReminder': 'Recordatorio diario',
  'settings.account': 'Cuenta',
  'settings.editProfile': 'Editar perfil',
  'settings.privacy': 'Privacidad',
  'settings.help': 'Ayuda',
  'settings.about': 'Acerca de',
  'settings.retakeTest': 'Repetir prueba de nivel',
  'settings.retakeTestDesc': 'Verifica tu nivel actual de coreano',
  'settings.terms': 'Términos de servicio',

  // ==================== FOOTER ====================
  'footer.privacy': 'Privacidad',
  'footer.terms': 'Términos',
  'footer.contact': 'Contacto',
  'footer.rights': 'Todos los derechos reservados.',

  // ==================== QUICK ACTIONS ====================
  'quickAction.vocabulary': 'Vocabulario',
  'quickAction.reviewWords': 'Repasar palabras',
  'quickAction.allCourses': 'Todos los cursos',
  'quickAction.browseLessons': 'Explorar lecciones',

  // ==================== COURSE DETAIL ====================
  'courseDetail.notFound': 'Curso no encontrado',
  'courseDetail.lessons': 'lecciones',
  'courseDetail.completed': 'completado',

  // ==================== BOTTOM NAVIGATION ====================
  'bottomNav.home': 'Inicio',
  'bottomNav.courses': 'Cursos',
  'bottomNav.vocab': 'Vocab',
  'bottomNav.profile': 'Perfil',

  // ==================== AI TUTOR ====================
  'aiTutor.title': 'Tutor IA',
  'aiTutor.selectScenario': 'Selecciona un escenario',
  'aiTutor.freeTalk': 'Conversación libre',
  'aiTutor.cafe': 'Pedido en café',
  'aiTutor.shopping': 'Compras',
  'aiTutor.restaurant': 'Restaurante',
  'aiTutor.friends': 'Hacer amigos',
  'aiTutor.interview': 'Entrevista de trabajo',
  'aiTutor.typeMessage': 'Escribe un mensaje...',
  'aiTutor.send': 'Enviar',

  // ==================== ERRORS ====================
  'error.generic': 'Algo salió mal',
  'error.network': 'Error de red. Por favor verifica tu conexión.',
  'error.notFound': 'Página no encontrada',
  'error.unauthorized': 'Por favor inicia sesión para continuar',
  'error.microphoneAccess': 'Acceso al micrófono denegado',
  'error.speechNotSupported': 'Reconocimiento de voz no soportado. Prueba con Chrome.',

  // ==================== COOKIE CONSENT ====================
  'cookie.title': 'Usamos cookies',
  'cookie.description': 'Usamos cookies para mejorar tu experiencia, analizar el tráfico del sitio y personalizar el contenido. Puedes elegir aceptar o rechazar las cookies no esenciales.',
  'cookie.learnMore': 'Más información',
  'cookie.acceptAll': 'Aceptar todas',
  'cookie.rejectAll': 'Rechazar todas',
  // ==================== ADDED (i18n audit 2026-10-24) ====================
  'nav.learn': 'Aprender',
  'nav.culture': 'Cultura',
  'nav.chat': 'Chat',
  'nav.ranking': 'Ranking',
  'nav.family': 'Familia',
  'nav.premium': 'Premium',
  'home.greeting': 'Hola',
  'home.streak': 'días seguidos',
  'home.dailyGoal': 'Meta diaria',
  'home.myLanguages': 'Mis idiomas',
  'home.addLanguage': 'Añadir idioma',
  'home.recommended': 'Recomendado',
  'home.continue': 'Seguir aprendiendo',
  'home.selectLanguage': 'Elige un idioma',
  'home.totalXp': 'XP total',
  'home.bestStreak': 'Mejor racha',
  'home.level': 'Nivel',
  'chat.aiTutor': 'Tutor IA',
  'chat.aiTutorDesc': 'Practica conversación con IA',
  'onboarding.welcome.subtitle': 'Aprende cualquier idioma con conversaciones por IA',
  'onboarding.selectUILanguage': 'Elige tu idioma',
  'onboarding.selectUILanguage.subtitle': 'Se usará para la interfaz de la app',
  'onboarding.selectLearningLanguage': '¿Qué quieres aprender?',
  'onboarding.selectLearningLanguage.subtitle': 'Puedes aprender varios idiomas',
  'onboarding.selectDailyGoal': 'Fija tu meta diaria',
  'onboarding.selectDailyGoal.subtitle': '¿Cuánto tiempo puedes dedicar al día?',
  'onboarding.ready': '¡Todo listo!',
  'onboarding.ready.subtitle': 'Empecemos tu aventura de aprendizaje',
  'onboarding.features.languages': '4 idiomas',
  'onboarding.features.aiTutor': 'Tutor IA',
  'onboarding.features.dailyGoals': 'Metas diarias',
  'dailyGoal.5min': '5 minutos',
  'dailyGoal.10min': '10 minutos',
  'dailyGoal.15min': '15 minutos',
  'dailyGoal.20min': '20 minutos',
  'dailyGoal.casual': 'Ritmo relajado',
  'dailyGoal.regular': 'Práctica regular',
  'dailyGoal.serious': 'Estudio serio',
  'dailyGoal.intense': 'Entrenamiento intensivo',
  'learn.title': 'Aprender',
  'learn.currentLevel': 'Nivel actual',
  'learn.noCoursesYet': '¡Muy pronto!',
  'learn.noCoursesDescription': 'Los cursos de este idioma están en preparación.',
  'learn.lessonsCompleted': 'lecciones completadas',
  'learn.startCourse': 'Empezar curso',
  'learn.continueCourse': 'Continuar',
  'learn.courseCompleted': 'Completado',
  'learn.locked': 'Bloqueado',
  'learn.unlockBy': 'Completa el curso anterior para desbloquear',
  'course.progress': 'Progreso',
  'course.lessons': 'Lecciones',
  'course.lessonsCompleted': 'lecciones completadas',
  'course.noLessons': 'Las lecciones están en preparación...',
  'lesson.tapToReveal': 'Toca para ver el significado',
  'lesson.examples': 'Ejemplos',
  'lesson.questionsCorrect': 'correctas',
  'lesson.wordsLearned': 'Palabras',
  'lesson.grammarPoints': 'Gramática',
  'lesson.backToCourse': 'Volver al curso',
  'lesson.practiceAgain': 'Practicar de nuevo',
  'lesson.whatYouLearn': 'Lo que aprenderás',
  'lesson.newWords': 'palabras nuevas',
  'lesson.exercises': 'ejercicios',
  'lesson.startLesson': 'Empezar lección',
  'lesson.reviewLesson': 'Repasar lección',
  'lesson.learnVocabulary': 'Aprender vocabulario',
  'lesson.grammarPoint': 'Punto gramatical',
  'lesson.practice': 'Practicar',
  'profile.guest': 'Invitado',
  'profile.days': 'días',
  'profile.longestStreak': 'Más larga',
  'profile.lessonsCompleted': 'completadas',
  'profile.dailyGoal': 'Meta diaria',
  'profile.learningLanguages': 'Idiomas que aprendes',
  'profile.noLanguages': 'Ningún idioma seleccionado',
  'profile.minutesPerDay': 'min/día',
  'profile.learningHistory': 'Historial de aprendizaje',
  'profile.viewProgress': 'Ver tu progreso',
  'profile.appSettings': 'Ajustes de la app',
  'profile.languageNotifications': 'Idioma, notificaciones',
  'profile.loginToSave': 'Inicia sesión para guardar tu progreso',
  'settings.learning': 'Aprendizaje',
  'settings.dailyGoal': 'Meta diaria',
  'settings.minutesPerDay': 'minutos al día',
  'settings.selectLanguage': 'Seleccionar idioma',
  'settings.selectDailyGoal': 'Fijar meta diaria',
  'settings.perDay': 'al día',
  'settings.appInfo': 'Información de la app',
  'settings.logout': 'Cerrar sesión',
};

export default es;
